export default "__VITE_ASSET__CP2X6mF2__"